import React from 'react';
import { Button, ButtonType, Form, Input } from 'syngenta-digital-cropwise-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';
import MailIcon from 'assets/icons/mail.svg';

// Assets
import NoWorkSpaceFoundImage from 'assets/images/empty_state_no_workspace_found.svg';
import NoplansFoundImage from 'assets/images/no_plans_found.svg';
import SeePlanImage from 'assets/images/see_plan.svg';

import './styles.less';
import { EventBus } from 'services/EventBus';
import { AppConstants } from 'core/app.constants';
import { redirectToActivateNewPlanDeepAction, translationWrapper, isUK } from 'utils/common-methods';
import { InfoModal } from 'components/AccountModal';

export const WORKSPACE_NOT_FOUND = 'no-workspace-found';
export const NO_PLANS_FOUND = 'no-plans-found';

export const EmptyStateWorkspaceContainer = (props: any) => {
    const { t } = translationWrapper(useTranslation());
    const { state = [], createPlanPermission, enableCreateWorkspaceOnAccountMng = false } = props;
    const showSeePlans = false;
    const getImage = () => {
        let image = NoWorkSpaceFoundImage;
        if (state.includes(NO_PLANS_FOUND)) {
            image = NoplansFoundImage;
        }
        return <img src={image} alt="No workspace found" />
    }

    const getSubTitle = () => {
        if (state.includes(WORKSPACE_NOT_FOUND)) {
            if (enableCreateWorkspaceOnAccountMng) {
                return <p className='sub-title'>
                    {t(`${isUK() ? 'text.create_a_workspace_to_activate_a_plan_and_use_syngenta':'text.create_a_workspace_to_activate_a_plan_and_use_cropwise'}`)}
                </p>
            }
        } else if (state.includes(NO_PLANS_FOUND) && !createPlanPermission) {
            return <p className='sub-title'>
                {t(`${isUK() ? 'text.ask_your_administrator_to_activate_a_plan_to_use_syngenta':'text.ask_your_administrator_to_activate_a_plan_to_use_cropwise'}`)}
            </p>
        } else if (state.includes(NO_PLANS_FOUND) && createPlanPermission) {
            return <p className='sub-title'>
                {t(`${isUK() ? 'text.please_activate_your_plan_to_use_syngenta':'text.please_activate_your_plan_to_use_cropwise'}`)}
            </p>
        }
    }

    return <>
        <div className='no-workspace-found-container'>
            {getImage()}
            <div className='title'>
                {state.includes(WORKSPACE_NOT_FOUND) ? t('info.no_workspace_found') : t('info.no_plan_found')}
            </div>
            {getSubTitle()}

            {
                (enableCreateWorkspaceOnAccountMng && state.includes(WORKSPACE_NOT_FOUND)) && <Button
                    className='create-workspace-button'
                    type={ButtonType.primary}
                    onClick={() => {
                        EventBus.$emit('workspaceEditEvent', {})
                    }}
                >
                    {t('button.create_workspace')}
                </Button>
            }

            {
                (state.includes(NO_PLANS_FOUND) && createPlanPermission) ? <Button
                    icon={<PlusOutlined />}
                    className='active-new-plan-button'
                    type={ButtonType.primary}
                    onClick={redirectToActivateNewPlanDeepAction}
                >
                    {t('button.activate_plan')}
                </Button> : <></>
            }


            {
                ( state.includes(WORKSPACE_NOT_FOUND) || state.includes(NO_PLANS_FOUND) ) ? <Button
                    className='learnmore-about-cropwise-button'
                    type={ButtonType.default}
                    onClick={() => {
                        window.open(isUK()?AppConstants.LINKS.UK:AppConstants.LINKS.CROPWISE, '_blank', 'noopener,noreferrer')
                    }}
                >
                    {t(`${isUK()?'button.learn_more_about_syngenta':'button.learn_more_about_cropwise'}`)}
                </Button> : <></>
            }


            {
                showSeePlans && <Button
                    className='see-plan-button'
                    type={ButtonType.default}
                    onClick={() => {
                        return false
                        // setOpenSeePlan(true)
                    }}
                >
                    {t('button.see_all')}
                </Button>
            }
        </div>


    </>
}

export const SeePlanModal = (props: any) => {
    const { openSeePlan, setOpenSeePlan, t } = props;
    return <InfoModal
        isModalVisible={openSeePlan}
        setIsModalVisible={setOpenSeePlan}
        disableFooter={true}
        titleLeftIcon={MailIcon}
        Image={SeePlanImage}
        accountModalData={{
            title: t(`global.text.${isUK() ? "want_to_see_syngenta_digital_plans": "want_to_see_cropwise_plans"}`),
            image: SeePlanImage,
            content: (
                <>
                    <p>
                        {t(`global.text.${isUK() ? "syngenta_digital": "cropwise"}_is_a_digital_farming_platform_that_brings_the_best_solutions`)}

                    </p>
                    <p>
                        {t(`global.text.${isUK() ? "syngenta_digital" : "cropwise"}_enter_your_name_and_email_below_to_receive_information`)}
                    </p>
                </>
            ),
        }}
    >
        <Form
            name="basic"
            layout="vertical"
            className='see-plan-modal'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{}}
            onFinish={() => false}
            onFinishFailed={() => false}
            autoComplete="off"
        >
            <Form.Item
                label={t("global.label.name")}
                name="name"
                rules={[{ required: true, message: t('global.text.enter_your_name') }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label={t("global.label.mail")}
                name="email"
                rules={[{ required: true, message: t('global.text.enter_your_mail') }]}
            >
                <Input />
            </Form.Item>
            <Form.Item className='see-plan-footer-action'>
                <Button className='see-plan-cancel-button' type={ButtonType.default} onClick={
                    () => { setOpenSeePlan(false) }
                }>
                    {t('global.button.cancel')}
                </Button>
                <Button type={ButtonType.primary} onClick={
                    () => { setOpenSeePlan(false) }
                }>
                    {t('global.button.send')}
                </Button>
            </Form.Item>
        </Form>
    </InfoModal>
}